// Constants for slot rendering and progressive disclosure
export const SLOT_CONSTANTS = {
  SLOTS_BY_ROW: 3,
  DEFAULT_SLOTS_COUNT: 6, // Always show 6 slots by default
  DEFAULT_ROWS_FEW_PROVIDERS: 2, // When there are few providers (≤2), show 2 rows
  DEFAULT_ROWS_MANY_PROVIDERS: 4, // When there are many providers (>2), show 4 rows
  PROVIDER_COUNT_THRESHOLD: 2,
  FLEX_STYLE: '1 0 30%',
} as const

// Time of day categories for slot diversity
export const TIME_CATEGORIES = {
  MORNING: 'morning', // 6 AM - 12 PM
  AFTERNOON: 'afternoon', // 12 PM - 6 PM
  EVENING: 'evening', // 6 PM - 12 AM
} as const

// Time ranges for categorization
export const TIME_RANGES = {
  MORNING_START: 6, // 6 AM
  AFTERNOON_START: 12, // 12 PM
  EVENING_START: 18, // 6 PM
  NIGHT_START: 0, // 12 AM (midnight)
} as const

// Phase definitions for progressive disclosure
export const PHASES = {
  LIMITED_SLOTS: 1,
  ALL_CURRENT_LEVEL: 2,
  CURRENT_AND_NEXT_LEVEL: 3,
  ALL_AVAILABLE: 4,
} as const

// Penalty levels
export const PENALTY_LEVELS = {
  NO_PENALTY: 'no-penalty',
  MEDIUM_PENALTY: 'medium-penalty',
  HIGH_PENALTY: 'high-penalty',
} as const

// Button text constants
export const BUTTON_TEXT = {
  MORE_AVAILABILITY: 'More availability',
  SHOW_LESS: 'Show less',
} as const

// CSS class names
export const CSS_CLASSES = {
  PROVIDER_SLOTS_CONTAINER: 'provider-slots-container mt-2',
  SLOT_ROW: 'd-flex mb-2',
  SLOT_CELL: 'flex-1 mx-1',
  EXPAND_BUTTON: 'cursor-pointer ff-inter-medium link see-more-availability',
  EXPAND_BUTTON_CONTAINER: 'd-flex justify-content-center mt-3',
  SHOW_LESS_BUTTON_CONTAINER: 'd-flex justify-content-center mt-2',
  FLEX_STYLE: '1 0 30%',
} as const

// Time format
export const TIME_FORMAT = 'h:mm aaa' as const
